import type { UsageTotals } from '@deskworks/shared-types';
import { intlLocale, t } from '@/lib/i18n';

export function formatTokens(n: number): string {
  const one = (x: number) => x.toLocaleString(intlLocale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  if (n >= 1_000_000_000) return t('{n}B', { n: one(n / 1_000_000_000) });
  if (n >= 1_000_000) return t('{n}M', { n: one(n / 1_000_000) });
  if (n >= 1_000) return `${Math.round(n / 1_000)}k`;
  return String(Math.round(n));
}

export function formatUsd(n: number): string {
  if (n === 0) return (0).toLocaleString(intlLocale, { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  if (Math.abs(n) < 0.01) return `<${(0.01).toLocaleString(intlLocale, { style: 'currency', currency: 'USD' })}`;
  return n.toLocaleString(intlLocale, { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const totalTokens = (u: Pick<UsageTotals, 'inputTokens' | 'outputTokens'>) => u.inputTokens + u.outputTokens;
export const totalUsd = (u: Pick<UsageTotals, 'apiCostUsd' | 'subscriptionValueUsd'>) => u.apiCostUsd + u.subscriptionValueUsd;

/** Optional monthly budget of an API runtime (runtime config `monthlyBudgetUsd`). */
export function monthlyBudget(config: Record<string, unknown>): number | null {
  const value = Number(config.monthlyBudgetUsd);
  return Number.isFinite(value) && value > 0 ? value : null;
}
